import React, { useEffect, useState, useRef } from "react";
import Layout from "../Layout/Layout";
import "../css/chat.css";
import ChatFriendList from "../Components/ChatFriendList";
import {
  MessageComponent,
  ChatReceive,
  ChatSend,
} from "../Components/Chat/ChatBody";
import AgoraChat from "agora-chat";
import { api } from "../actions/api";
import { ChatMessageBox } from "../Components/Chat/AgoraChatMessageBox";
import { ReceiveChat, SendChat } from "../Components/Chat/AgoraChatBody";
import { toast } from "react-toastify";
import formatMessageTime from "../Utils/formattedTime";
import { getProfile } from "../actions/login";

export default function Chat() {
  const [profile, setProfile] = useState(null);
  const chatClient = useRef(null); // ✅ useRef instead of useState

  // Fetch user profile
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const userProfile = await getProfile();
        setProfile(userProfile);
      } catch (error) {
        console.error("Failed to fetch profile:", error);
      }
    };

    fetchProfile();
  }, []);

  // Initialize chat when profile is available
  useEffect(() => {
    if (profile?.slug && profile?.agora_user_token) {
      initChat(profile.slug, profile.agora_user_token).catch((error) => {
        console.error("Chat initialization failed:", error);
      });
    }
  }, [profile]);

  const initChat = async (userId, token) => {
    if (!chatClient.current) {
      chatClient.current = chatClient.current.open({
        appKey: "611346004#1551561",
      });

      chatClient.current.addEventHandler("connection", {
        onConnected: () => {},
        onDisconnected: () => {},
        onTextMessage: (message) => {},
      });
    }

    try {
      await chatClient.current.open({
        user: userId,
        accessToken: token,
      });


    } catch (error) {
      console.error("Agora Chat login failed:", error);
    }
  };

  return <Layout showHeader={false}>this is a test page for agora chat</Layout>;
}
